<template>
  <div class="main">
    <el-row :span="26"
            type="flex"
            justify="space-around">
      <el-col :span="4"
              class="table">
        <h3>现有员工</h3>
        <p>16个</p>
      </el-col>
      <el-col :span="4"
              class="table">
        <h3>当前在岗</h3>
        <p>16个</p>
      </el-col>
      <el-col :span="4"
              class="table">
        <h3>今日迟到</h3>
        <p>16个</p>
      </el-col>
      <el-col :span="8">
      </el-col>
      <el-col :span="4"
              style="align-self:center;">
        <el-button type="primary">点击进入员工列表</el-button>
      </el-col>
    </el-row>
    <div class="table">
      <el-row :span="20"
              type="flex"
              justify="space-around">
        <el-col :span="13">
          <h1>有2个批次产品正在生产中</h1>
        </el-col>
        <el-col :span="5"
                style="align-self:center;">
          <el-button type="primary">点击进入批次列表</el-button>
        </el-col>
      </el-row>
    </div>
    <el-row :span="20"
            type="flex"
            class="table"
            justify="space-around">
      <el-col :span="11"
              class="table">
        <h1 style="padding-top: 15px;">批次1</h1>
        <el-table :data="tableData"
                  style="width: 100%">
          <el-table-column prop="name"
                           label="工序名称">
          </el-table-column>
          <el-table-column prop="number"
                           label="工序总数">
          </el-table-column>
          <el-table-column prop="schedule"
                           label="完成进度">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="11"
              class="table">
        <h1 style="padding-top: 15px;">批次2</h1>
        <el-table :data="tableData"
                  style="width: 100%">
          <el-table-column prop="name"
                           label="工序名称">
          </el-table-column>
          <el-table-column prop="number"
                           label="工序总数">
          </el-table-column>
          <el-table-column prop="schedule"
                           label="完成进度">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

  </div>
</template>
<script>
export default {
  data () {
    return {
      tableData: [{
        name: '兜兜',
        number: '120',
        schedule: '100%'
      }, {
        name: '兜兜',
        number: '120',
        schedule: '100%'
      }, {
        name: '兜兜',
        number: '120',
        schedule: '100%'
      }, {
        name: '兜兜',
        number: '120',
        schedule: '100%'
      }, {
        name: '兜兜',
        number: '120',
        schedule: '100%'
      }, {
        name: '兜兜',
        number: '120',
        schedule: '100%'
      }]
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.main {
  height: 100%;
  width: 100%;
}
.table {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  margin-top: 5px;
}
</style>
